import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setWechatTitle } from '../utils/wechatTitle';
import FloatBackButton from '../components/FloatBackButton';
import RichTextDisplay from '../components/RichTextDisplay';
import { useWechatShare, updateWxShareData } from '../utils/wechatShare';
import { ThematicRouteModel } from '../models/thematicRouteModel';

const ThematicRouteDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState('');

  const getDetail = useCallback(async () => {
    const pathParts = location.pathname.split('/');
    const id = pathParts[3];
        console.log('-----id-----', id,pathParts);
    if (id) {
      try {
        const data = await ThematicRouteModel.getDetail({id});
        console.log('-----data-----', data);
        setDetail(data);
        setWechatTitle(data.name);
        
      } catch (err) {
        console.error('商户数据加载失败', err);
        const errMsg = '加载数据失败，请重试';
        setError(errMsg);
        // Toast.show({ content: errMsg, type: 'fail' });
      } finally {
      }
    }
  }, [location.pathname]);
  
  // 从URL解析商户信息并设置标题
  useEffect(() => {
    getDetail();
  }, [getDetail]);
  
  // 微信分享配置
  const { wx, configured } = useWechatShare(
    detail?.name || '推荐路线',
    '',
    '',
  );

  // 更新分享配置
  useEffect(() => {
    if (detail && configured && wx) {
      console.log(JSON.stringify({
        title: detail.name,
        desc: '',
        imgUrl: '',
        link: window.location.href
      }, null, 2));
      updateWxShareData(wx,{
        title: detail.name,
        desc: '',
        imgUrl: '',
        link: window.location.href
      });
    }
  }, [detail, configured, wx]);
  
  // 加载中状态
  if (!detail) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>加载中...</p>
      </div>
    );
  }

  if (error && !detail) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-red-500">
        <p>{error}</p>
        <button
          onClick={() => getDetail()}
          className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
        >
          重试
        </button>
      </div>
    );
  }

  
  return (
    <div className="min-h-screen flex flex-col">
      <div className="p-4">
      <div className="flex ">
        <FloatBackButton flex={false} onClick={() => navigate('/')} />
        <h2 className="text-center flex-1" style={{lineHeight: 1.8}}>{detail.name}</h2>
      </div>
      <div className="p-4">
        <RichTextDisplay htmlContent={detail.introduction} />
      </div>
      </div>
    </div>
  );
};

export default ThematicRouteDetail;